import { Injectable, Optional, Host, SkipSelf, Component } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { AppInjector } from '../../controls/bnsights-library.module';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AbstractControl, ControlContainer, ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl, FormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';



@Injectable()
export class UtilityService {

    static isCreatedBefor = false;
    static Translator: any = null;
    static CurrentLanguage: string = localStorage.getItem('language');

    @BlockUI() blockUI: NgBlockUI;

    static showGlobalError() {
        let globalErorrElement = document.getElementsByClassName('alert alert-danger alert-InvalidValidation')
        if (globalErorrElement.length > 0) {
            this.removeElementsByClass('alert alert-danger alert-InvalidValidation');
        }

        if (UtilityService.isCreatedBefor == true) {
            this.removeElementsByClass('alert alert-danger alert-InvalidValidation');
        }
        // tslint:disable-next-line: prefer-const
        var objects = document.getElementsByClassName("ng-invalid ng-dirty ng-touched");
        const tagName = 'div';
        // tslint:disable-next-line: prefer-const
        var elementToAppend = document.createElement(tagName); // Your tag name here
        let message = "";
        if (localStorage.getItem('language') == "ar")
            message = "لديك بعص الأخطاء . من فضلك قم بالمراجعه ";
        else
            message = "You have some validation errors. Please check below"

        elementToAppend.innerHTML = "<ul><li>" + message + "</li></ul>";
        elementToAppend.className += 'alert alert-danger alert-InvalidValidation';
            elementToAppend.id += 'errorId';
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < objects.length; i++) {
            // const elementToAppen = elementToAppend.cloneNode(true);
            // objects[i].insertBefore(elementToAppen, objects[i].firstChild);
            const elementToAppen = elementToAppend.cloneNode(true);
            let targetElement = objects[i].getElementsByClassName("b-control")[0];
            targetElement.parentNode.insertBefore(elementToAppen, targetElement);
            UtilityService.isCreatedBefor = true;
            break;
        }

    }



    static RemoveGlobalError() {
        const removedList = document.getElementsByClassName('alert alert-danger alert-InvalidValidation');
        // tslint:disable-next-line: prefer-for-of
        for (let index = 0; index < removedList.length; index++) {
            const element = removedList[index];
            element.remove();
        }
        UtilityService.isCreatedBefor = false;
    }

    static showInputErro(errors: any) {

        // show error on top of form 
        this.showGlobalError();
        // remove old error from server
        this.removeElementsByClass('errortemplet');
        // Looping in error Object
        for (const key in errors) {
            if (errors.hasOwnProperty(key)) {
                for (const iterator of errors[key]) {
                    const input = document.querySelectorAll('[ng-reflect-name=' + key + ']')[0];
                    if ((input.attributes['ng-reflect-name'].value as string) === key) {
                        this.removeElementsByClass('erroclass-' + key);
                        const tagName = 'p'
                        const elementToAppend = document.createElement(tagName); // Your tag name here
                        elementToAppend.innerHTML = iterator;
                        elementToAppend.style.color = 'red'
                        elementToAppend.className += 'errortemplet erroclass-' + key;
                        const elementToappen = elementToAppend.cloneNode(true);
                        input.parentNode.insertBefore(elementToappen, input.lastChild);
                        break;
                    }
                }
            }
        }
    }

    static getResourceValue(Key: string): string {
        let translator = UtilityService.Translator;;
        let ResourceValue = "";
        translator.get(Key).subscribe(data => { ResourceValue = data; });
        return ResourceValue;

    }
    // static getResourceValue(Key:string):string
    // {
    //     let translator = AppInjector.get(TranslateService);
    //     translator.use(UtilityService.CurrentLanguage);
    //     translator.onLangChange
    //     let ResourceValue = "";
    //     translator.get(Key).subscribe(data => { ResourceValue = data; });
    //     return ResourceValue;

    // }




    static notifySuccessMassage(massage?: string, title?: string, time?: number) {

        let massageTemplet = ' Your action submitted successfully'
        let titleTemplet = 'Successfully';
        if (massage != null) {
            massageTemplet = massage;
        }
        if (title != null) {
            titleTemplet = title;
        }
        
        let toastr = AppInjector.get(ToastrService);
        toastr.success(massageTemplet, titleTemplet,{timeOut:time,closeButton:true});
    }

    static notifyErrorMassage(massage?: string, title?: string, time?: number) {

        let massageTemplet = ' Sorry,Some thing is go Wrong '
        let titleTemplet = 'Error';
        if (massage != null) {
            massageTemplet = massage;
        }
        if (title != null) {
            titleTemplet = title;
        }
        const toastr = AppInjector.get(ToastrService);
        toastr.error(massageTemplet, titleTemplet,{timeOut:time,closeButton:true});
    }

    static notifyWorningMassage(massage?: string, title?: string, time?: number) {

        let massageTemplet = 'Worrning Massage'
        let titleTemplet = 'Worning';
        if (massage != null) {
            massageTemplet = massage;
        }
        if (title != null) {
            titleTemplet = title;
        }
        const toastr = AppInjector.get(ToastrService);
        toastr.warning(massageTemplet, titleTemplet,{timeOut:time,closeButton:true});
    }

    static blockUI() {
        const utilityServiceObject = new UtilityService();
        utilityServiceObject.blockUi();

    }

    static endBlockUI() {
        const utilityServiceObject = new UtilityService();
        utilityServiceObject.endBlockUi();

    }
    static removeElementsByClass(className) {
        const elements = document.getElementsByClassName(className);
        while (elements.length > 0) {
            elements[0].parentNode.removeChild(elements[0]);
        }
    }


    blockUi() {
        this.blockUI.start();
    }
    endBlockUi() {
        this.blockUI.stop();
    }
}
